import { Line } from './line';

export const Circle = (size: number = 18) => Line(size, size, 99);
